import { makeAutoObservable } from 'mobx'
import RootStore from 'src/stores'

export default class HeaderViewModel {
  private RootStore: RootStore

  isOpenMenu = false

  get isLoggedIn() {
    return this.RootStore.AuthStore.isLoggedIn
  }

  get userName() {
    return this.RootStore.AuthStore.user?.name || ''
  }

  setIsOpenMenu = (isOpenMenu: boolean) => {
    this.isOpenMenu = isOpenMenu
  }

  constructor(RootStore: RootStore) {
    this.RootStore = RootStore
    makeAutoObservable(this)
  }
}
